import React from 'react';
import { Zap, Sparkles, Star } from 'lucide-react';

export const Hero = () => {
  return (
    <section className="text-center mb-16">
      <h1 className="text-5xl font-bold mb-8">Lead Wealth A.I.</h1>
      <h2 className="text-3xl mb-6">Revolutionize Your Marketing</h2>
      
      <div className="flex justify-center items-center mb-8">
        <Zap className="text-yellow-400 mr-4 animate-float" size={48} />
        <Sparkles className="text-yellow-400 mr-4 animate-float" size={48} />
        <Star className="text-yellow-400 animate-float" size={48} />
      </div>
      
      <p className="text-xl mb-8 max-w-2xl mx-auto">
        Unlock the power of AI to revolutionize your financial services business. Generate high-quality leads, automate your marketing, and skyrocket your success.
      </p>
    </section>
  );
};